export type InputColor = 'primary' | 'secondary';

export const knownInputColors = ['primary', 'secondary'];
